window.specificationAccordionMenu = function specificationAccordionMenu() {
    'use strict'

    if ($(window).width() < 670) {
        $('.specification .listsWrapper > div h3').removeClass('open');
        $('.specification .listsWrapper > div ul').hide();

        $('.specification .listsWrapper > div:first-child h3').addClass('open');
        $('.specification .listsWrapper > div:first-child ul').show();

        $('.specification .listsWrapper > div h3').on('click', function () {
            if (!$(this).hasClass('open')) {
                $('.specification .listsWrapper > div h3').removeClass('open');
                $('.specification .listsWrapper > div ul').slideUp();
                $(this).next('ul').slideDown();
                $(this).addClass('open');
            }
        });
    } else {
        $('.specification .listsWrapper > div h3').removeClass('open');
        $('.specification .listsWrapper > div ul').show();

    }
}

$(document).ready(function () {
    'use strict';

    specificationAccordionMenu();
});

$(window).on('resize', debouncer(function (e) {
    'use strict';

    specificationAccordionMenu();
}));